export interface EgresoEmailAttachment {
  name: string;
  remoteId?: string;
}

export interface ExpenseItem {
  supplier: string;
  file: string;
  code: string;
  bookingCode?: string;
  amount: number;
  currency: string;
  userEmail: string;
  notes?: string;
}

export interface SendEgresoEmailRequest {
  to: string;
  cc?: string;
  subject: string;
  attachment: EgresoEmailAttachment;
  mainMessage: string;
  expenseList: ExpenseItem[];
}

export interface SendEgresoEmailResponse {
  message?: string;
  statusCode?: number;
  [key: string]: any;
}
